import { render, staticRenderFns } from "./CoverImageSettingDialog.vue?vue&type=template&id=02258bd4&scoped=true"
import script from "./CoverImageSettingDialog.vue?vue&type=script&setup=true&lang=ts"
export * from "./CoverImageSettingDialog.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./CoverImageSettingDialog.vue?vue&type=style&index=0&id=02258bd4&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02258bd4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/nola-frontend/nola-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('02258bd4')) {
      api.createRecord('02258bd4', component.options)
    } else {
      api.reload('02258bd4', component.options)
    }
    module.hot.accept("./CoverImageSettingDialog.vue?vue&type=template&id=02258bd4&scoped=true", function () {
      api.rerender('02258bd4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/ui/novel/CoverImageSettingDialog.vue"
export default component.exports